import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin, Select } from "antd";
import React, { useState } from "react";
import CreateScaleUnitApi from "../../../api/scale-unit/CreateScaleUnitApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { getCurrencyCodes } from "../../../helpers/currencyCodes";

const { Option } = Select;

function AddScaleUnitsModal(props) {
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreateScaleUnitApi(
      values.unitName,
      values.symbol,
      values.abbreviation,
      props.scaleId
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Scale unit added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add scale unit. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Add custom scale unit"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="unit"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Unit"
          name="unitName"
          rules={[{ required: true, message: "Please enter a unit name!" }]}
        >
          <Input placeholder="unit" />
        </Form.Item>

        <Form.Item
          label="Symbol"
          name="symbol"
          rules={[{ required: true, message: "Please enter symbol!" }]}
        >
          <Input placeholder="symbol" />
        </Form.Item>

        <Form.Item
          label="Abbreviation"
          name="abbreviation"
          rules={[{ required: true, message: "Please enter abbreviation!" }]}
        >
          <Select
            showSearch
            placeholder="Select a currency"
            optionFilterProp="children"
          >
            {getCurrencyCodes.map((code) => (
              <Option key={code} value={code}>
                {code}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddScaleUnitsModal;
